import {
  CButton,
  CCardHeader,
  CCol,
  CInputGroup,
  CLabel,
  CRow,
} from "@coreui/react";
import React from "react";
// import usersData from "../users/UsersData";

const BankGuaranteePayment = () => {
  return (
    <>
      <CCardHeader className="mb-3 shadow-sm">
        <CRow className="pt-3" xl={12}>
          <CCol xl={10}>
            <h3>Bank Guarantee Payment</h3>
          </CCol>
        </CRow>
        <hr />

        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Upload Bank Guarantee Receipt :
            </CLabel>
          </CCol>

          <CCol xl={4}>
            <CInputGroup className="mb-3">
              <div class="custom-file">
                <input
                  id="inputGroupFile01"
                  type="file"
                  className="custom-file-input"
                />
                <label className="custom-file-label " for="inputGroupFile01">
                  Choose file
                </label>
              </div>
            </CInputGroup>
          </CCol>
        </CRow>

        <CRow className="mb-3">
          <CCol sm="auto"> </CCol>
          <CButton color="success">Submit</CButton>
        </CRow>
      </CCardHeader>
    </>
  );
};
export default BankGuaranteePayment;
